import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
})
export class CookiePolicyComponent implements OnInit {
  ngOnInit() {
    const embedTag = document.getElementById('termly-embed');
    if (embedTag) {
      embedTag.innerHTML = '';
    }

    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }
}
